import { classes as a } from "../classes/classes.js";
import '../assets/CheckBoxList.css';const r = "op_listHolder_6r3l6", f = "op_fieldLabel_mfkcp", x = "op_checkbox_nmYha", H = "op_labelCheckboxHolder_c5hTX", L = "op_formLabels_IHwIz", l = {
  listHolder: r,
  fieldLabel: f,
  checkbox: x,
  labelCheckboxHolder: H,
  formLabels: L
};
function N(e) {
  var b;
  let m = e.choices ? e.choices.map(function(i, o) {
    var s;
    let {
      inputAttributes: c = {},
      holderAttributes: d = {},
      labelAttributes: t = {},
      label: h,
      preLabel: n,
      postLabel: k
    } = i;
    return /* @__PURE__ */ React.createElement("div", { key: "checkbox-" + o + "-" + e.id, ...d, className: a(l.labelCheckboxHolder, (s = e == null ? void 0 : e.holderAttributes) == null ? void 0 : s.className) }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "Checkbox",
        id: "checkbox-" + o + "-" + e.id,
        ...c,
        className: a(l.checkbox, c == null ? void 0 : c.className)
      }
    ), /* @__PURE__ */ React.createElement("label", { htmlFor: "checkbox-" + o + "-" + e.id, className: l.formLabels }, n, /* @__PURE__ */ React.createElement("span", { ...t, className: a(l.fieldLabel, t == null ? void 0 : t.className) }, h), k));
  }) : [];
  return /* @__PURE__ */ React.createElement("div", { ...e == null ? void 0 : e.listHolderAttributes, className: a(l.listHolder, (b = e == null ? void 0 : e.listHolderAttributes) == null ? void 0 : b.className) }, m);
}
export {
  N as CheckBoxList
};
